module.exports = __webpack_public_path__ + "static/img/sand_detail.226a4c4b.png";